import React from 'react';
import classnames from 'classnames';
import PropTypes from 'prop-types';

import './title.scss';

const Title = ({text, className}) => <div className={classnames('title', className)}>{text}</div>;

Title.propTypes = {
  text: PropTypes.string.isRequired,
  className: PropTypes.string,
};

Title.defaultProps = {
  className: '',
};

export default Title;
